(function () {
  if (window.__wsmSingleProductCheckoutCanonicalV1) return;
  window.__wsmCanonicalCheckoutOwnerClaimV1 = true;
  window.__wsmSingleProductCheckoutCanonicalV1 = true;
  window.__wsmSingleProductCheckoutGuardV3 = true;
  window.__wsmSingleProductCheckoutOwner = 'canonical-v1';

  var inFlight = false;
  var checkoutNavigationPending = false;
  var exactCartProofKey = 'wsm_exact_single_product_cart_proof_v1';
  var exactCartProofTtlMs = 15 * 60 * 1000;

  window.__wsmExitLandingOfferV1 = true;
  var exitLandingOfferParamsKey = 'wsm_exit_landing_offer_params';
  var exitLandingOfferExpiresKey = 'wsm_exit_landing_offer_expires_at';

  function safeStorageGet(storage, key) {
    try { return storage ? storage.getItem(key) : ''; } catch (error) { return ''; }
  }

  function safeStorageSet(storage, key, value) {
    try { if (storage) storage.setItem(key, value); } catch (error) {}
  }

  function safeStorageRemove(storage, key) {
    try { if (storage) storage.removeItem(key); } catch (error) {}
  }

  function clearExactCartProof() {
    safeStorageRemove(sessionStorage, exactCartProofKey);
  }

  function rememberExactCartProof(variantId) {
    safeStorageSet(sessionStorage, exactCartProofKey, JSON.stringify({
      variantId: String(variantId || ''),
      quantity: 1,
      confirmedAt: Date.now()
    }));
  }

  function hasRecentExactCartProof(variantId) {
    var raw = safeStorageGet(sessionStorage, exactCartProofKey);
    if (!raw) return false;
    try {
      var proof = JSON.parse(raw);
      var valid = proof &&
        String(proof.variantId || '') === String(variantId || '') &&
        Number(proof.quantity || 0) === 1 &&
        Number(proof.confirmedAt || 0) > Date.now() - exactCartProofTtlMs;
      if (valid) return true;
    } catch (error) {}
    clearExactCartProof();
    return false;
  }

  function safeCookieValue(key) {
    try {
      var pairs = String(document.cookie || '').split(';');
      for (var i = 0; i < pairs.length; i += 1) {
        var pair = pairs[i].trim();
        if (pair.indexOf(key + '=') === 0) return decodeURIComponent(pair.slice(key.length + 1));
      }
    } catch (error) {}
    return '';
  }

  function normalizeOfferParams(sourceParams) {
    var params = new URLSearchParams(sourceParams && sourceParams.toString ? sourceParams.toString() : '');
    if (!params.get('discount')) params.set('discount', 'POP20');
    if (!params.get('type')) params.set('type', 'percent');
    if (!params.get('value')) params.set('value', '20');
    if (!params.get('minutes')) params.set('minutes', '15');
    return params;
  }

  function parseOfferMinutes(params) {
    var minutes = parseInt(params && params.get ? (params.get('minutes') || params.get('min')) : '', 10);
    return Number.isFinite(minutes) && minutes > 0 ? minutes : 15;
  }

  function rememberExitLandingOffer(params) {
    var normalized = normalizeOfferParams(params);
    var expiresAt = Date.now() + parseOfferMinutes(normalized) * 60 * 1000;
    [sessionStorage, localStorage].forEach(function (storage) {
      safeStorageSet(storage, exitLandingOfferParamsKey, normalized.toString());
      safeStorageSet(storage, exitLandingOfferExpiresKey, String(expiresAt));
    });
    return normalized;
  }

  function storedExitLandingOfferParams() {
    var expiresAt = parseInt(safeStorageGet(sessionStorage, exitLandingOfferExpiresKey) || safeStorageGet(localStorage, exitLandingOfferExpiresKey), 10);
    var raw = safeStorageGet(sessionStorage, exitLandingOfferParamsKey) || safeStorageGet(localStorage, exitLandingOfferParamsKey) || '';
    if (Number.isFinite(expiresAt) && expiresAt > Date.now() && raw) return new URLSearchParams(raw);

    [exitLandingOfferParamsKey, exitLandingOfferExpiresKey].forEach(function (key) {
      [sessionStorage, localStorage].forEach(function (storage) { safeStorageRemove(storage, key); });
    });

    var legacyKeys = ['wsm_v3d_one_time_offer_v68', 'wsm_v3d_one_time_offer_test_v1'];
    for (var i = 0; i < legacyKeys.length; i += 1) {
      var legacyRaw = safeStorageGet(sessionStorage, legacyKeys[i]) || safeStorageGet(localStorage, legacyKeys[i]) || safeCookieValue(legacyKeys[i]);
      if (!legacyRaw) continue;
      try {
        var offer = JSON.parse(legacyRaw);
        if (offer && offer.expiresAt && offer.expiresAt <= Date.now()) continue;
        var params = new URLSearchParams();
        params.set('discount', offer.discountCode || offer.discount || 'POP20');
        params.set('type', offer.discountType || offer.type || 'percent');
        params.set('value', String(offer.discountValue || offer.value || '20'));
        params.set('minutes', String(offer.minutes || '15'));
        return params;
      } catch (error) {}
    }
    return new URLSearchParams();
  }

  function mergeExitLandingOfferParams(sourceParams) {
    var merged = new URLSearchParams(sourceParams && sourceParams.toString ? sourceParams.toString() : '');
    var stored = storedExitLandingOfferParams();
    stored.forEach(function (value, key) {
      if (!merged.get(key)) merged.set(key, value);
    });
    return merged;
  }

  function isExitOfferCta(anchor) {
    return !!(anchor && anchor.matches && (
      anchor.matches('[data-wsm-oto-exit-cta]') ||
      (anchor.closest && anchor.closest('[data-wsm-oto-exit-popup]'))
    ));
  }

  function closeExitOfferPopup(anchor) {
    var popup = anchor && anchor.closest ? anchor.closest('[data-wsm-oto-exit-popup]') : document.querySelector('[data-wsm-oto-exit-popup]');
    var backdrop = document.querySelector('[data-wsm-oto-exit-backdrop]');
    [popup, backdrop].forEach(function (el) {
      if (!el) return;
      el.classList.remove('is-visible');
      el.setAttribute('hidden', 'hidden');
      el.hidden = true;
    });
    document.documentElement.classList.remove('wsm-oto-exit-modal-open');
  }

  function activateExitLandingOffer(anchor, sourceParams) {
    var params = rememberExitLandingOffer(sourceParams);
    persistExitCheckoutOffer(params);
    safeStorageSet(sessionStorage, 'wsm_global_oto_exit_clicked', '1');
    safeStorageSet(sessionStorage, 'wsm_global_oto_exit_closed', '1');
    closeExitOfferPopup(anchor);
    try { restoreStoredExitOffer(); } catch (error) {}
    window.setTimeout(function () { try { restoreStoredExitOffer(); } catch (error) {} }, 100);
    window.setTimeout(function () { try { restoreStoredExitOffer(); } catch (error) {} }, 600);
    try {
      window.dispatchEvent(new CustomEvent('wsm:exit-offer-activated', { detail: { params: params.toString() } }));
    } catch (error) {}
  }


  function closestAnchor(target) {
    return target && target.closest ? target.closest('a[href]') : null;
  }

  function closestForm(target) {
    return target && target.closest ? target.closest('form') : null;
  }

  function urlFromHref(href) {
    try {
      return new URL(href, window.location.href);
    } catch (error) {
      return null;
    }
  }

  function isCartAddUrl(url) {
    return url && /\/cart\/add(?:\.js)?$/i.test(url.pathname) && url.searchParams.get('id');
  }

  function isCheckoutCartAdd(anchor, url) {
    if (!anchor || !isCartAddUrl(url)) return false;
    var returnTo = String(url.searchParams.get('return_to') || '').toLowerCase();
    var text = String(anchor.textContent || '').toLowerCase();
    return returnTo.indexOf('/checkout') !== -1 ||
      /enroll|checkout|join|get elite|claim/.test(text) ||
      anchor.classList.contains('btn-orange') ||
      anchor.classList.contains('wsm-oto-popup-cta');
  }

  function paramsFromHash(href) {
    var index = String(href || '').indexOf('?');
    return new URLSearchParams(index === -1 ? '' : String(href).slice(index + 1));
  }

  function findCurrentVariantId(anchor) {
    var href = anchor && anchor.getAttribute ? anchor.getAttribute('href') : '';
    var url = href ? urlFromHref(href) : null;
    if (isCartAddUrl(url)) return url.searchParams.get('id');

    var scoped = anchor && anchor.closest ? anchor.closest('section, main, body') : document;
    var linked = scoped && scoped.querySelector ? scoped.querySelector('a[href*="/cart/add"][href*="id="]') : null;
    if (!linked && document.querySelector) linked = document.querySelector('a[href*="/cart/add"][href*="id="]');
    if (linked) {
      var linkedUrl = urlFromHref(linked.getAttribute('href'));
      if (isCartAddUrl(linkedUrl)) return linkedUrl.searchParams.get('id');
    }

    return '';
  }

  function checkoutPath(sourceParams) {
    var params = new URLSearchParams();
    var discount = sourceParams && sourceParams.get ? sourceParams.get('discount') : '';
    var email = sourceParams && sourceParams.get ? (sourceParams.get('checkout[email]') || sourceParams.get('email')) : '';

    if (discount) params.set('discount', discount);
    if (email) params.set('checkout[email]', email);

    var query = params.toString();
    return '/checkout' + (query ? '?' + query : '');
  }

  function persistExitCheckoutOffer(sourceParams) {
    // wsmPersistExitCheckoutOffer20260707: save the 15-minute POP20 state before checkout redirects.
    if (!sourceParams || !sourceParams.get) return;
    var discount = String(sourceParams.get('discount') || sourceParams.get('code') || '').trim();
    if (!discount) return;

    var type = String(sourceParams.get('type') || sourceParams.get('discountType') || 'percent').trim().toLowerCase() || 'percent';
    var value = parseFloat(sourceParams.get('value') || sourceParams.get('discountValue') || '20');
    var minutes = parseInt(sourceParams.get('minutes') || sourceParams.get('min') || '15', 10);
    if (!isFinite(value) || value <= 0) value = 20;
    if (!isFinite(minutes) || minutes <= 0) minutes = 15;

    try {
      if (window.WSMV3DOneTimeOffer && typeof window.WSMV3DOneTimeOffer.activate === 'function') {
        window.WSMV3DOneTimeOffer.activate({
          discount: discount,
          type: type,
          value: String(value),
          minutes: String(minutes)
        });
        return;
      }
    } catch (error) {}

    var offer = {
      discountCode: discount,
      discountType: type,
      discountValue: value,
      minutes: minutes,
      createdAt: Date.now(),
      expiresAt: Date.now() + (minutes * 60 * 1000)
    };
    var raw = JSON.stringify(offer);
    var keys = ['wsm_v3d_one_time_offer_v68', 'wsm_v3d_one_time_offer_test_v1'];
    keys.forEach(function (key) {
      try { window.localStorage.setItem(key, raw); } catch (error) {}
      try { window.sessionStorage.setItem(key, raw); } catch (error) {}
      try {
        document.cookie = key + '=' + encodeURIComponent(raw) + '; path=/; max-age=' + String(minutes * 60) + '; SameSite=Lax';
      } catch (error) {}
    });
  }

  function exactSingleProductCartUrl(variantId, sourceParams) {
    var params = new URLSearchParams();
    var discount = sourceParams && sourceParams.get ? sourceParams.get('discount') : '';
    var email = sourceParams && sourceParams.get ? (sourceParams.get('checkout[email]') || sourceParams.get('email')) : '';

    if (discount) params.set('discount', discount);
    if (email) params.set('checkout[email]', email);

    var query = params.toString();
    return '/cart/' + encodeURIComponent(variantId) + ':1' + (query ? '?' + query : '');
  }

  function setBusy(anchor) {
    if (!anchor || !anchor.setAttribute) return;
    anchor.setAttribute('aria-busy', 'true');
    anchor.setAttribute('data-wsm-checkout-busy', 'true');
    if (!anchor.dataset.wsmOriginalText) anchor.dataset.wsmOriginalText = anchor.textContent || '';
    if (/enroll|checkout|join|get elite|claim/i.test(anchor.textContent || '')) {
      anchor.textContent = 'Continuing...';
    }
  }

  function resetBusyState() {
    inFlight = false;
    document.querySelectorAll('[data-wsm-checkout-busy="true"]').forEach(function (anchor) {
      anchor.removeAttribute('aria-busy');
      anchor.removeAttribute('aria-disabled');
      anchor.removeAttribute('disabled');
      anchor.removeAttribute('data-wsm-checkout-busy');
      if (anchor.dataset && anchor.dataset.wsmOriginalText) {
        anchor.textContent = anchor.dataset.wsmOriginalText;
        delete anchor.dataset.wsmOriginalText;
      }
    });
  }

  function postJson(path, body) {
    var options = {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    };
    if (body !== undefined) options.body = JSON.stringify(body);
    return fetch(path, options).then(function (response) {
      if (!response.ok) {
        var error = new Error('Cart request failed with HTTP ' + response.status + '.');
        var retryAfterSeconds = parseFloat(response.headers.get('retry-after') || '0');
        error.retryAfterMs = isFinite(retryAfterSeconds) && retryAfterSeconds > 0
          ? Math.min(5000, retryAfterSeconds * 1000)
          : 2000;
        throw error;
      }
      return response;
    });
  }

  function responseJson(response, label) {
    return response.json().catch(function () {
      throw new Error((label || 'Cart response') + ' did not return valid JSON.');
    });
  }

  function settleCompetingCartHandlers() {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, 350);
    });
  }

  function isExactSingleProductCart(cart, variantId) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    if (items.length !== 1) return false;
    return String(items[0].variant_id || items[0].id || '') === String(variantId) &&
      Number(items[0].quantity || 0) === 1;
  }

  async function replaceCartWithSingleProduct(variantId) {
    var lastError = null;
    for (var attempt = 0; attempt < 2; attempt += 1) {
      try {
        var clearedResponse = await postJson('/cart/clear.js');
        var clearedCart = await responseJson(clearedResponse, 'Cart clear');
        if (!clearedCart || !Array.isArray(clearedCart.items) || clearedCart.items.length !== 0) {
          throw new Error('Cart clear response was not empty.');
        }

        await settleCompetingCartHandlers();

        var updates = {};
        updates[String(variantId)] = 1;
        var normalizedResponse = await postJson('/cart/update.js', { updates: updates });
        var cart = await responseJson(normalizedResponse, 'Cart normalization');
        if (isExactSingleProductCart(cart, variantId)) {
          rememberExactCartProof(variantId);
          return cart;
        }
        lastError = new Error('Cart normalization response was not exactly one line and one unit.');
      } catch (error) {
        lastError = error;
        if (attempt < 1) {
          await new Promise(function (resolve) {
            window.setTimeout(resolve, Math.max(1200, Math.min(5000, Number(error && error.retryAfterMs) || 2000)));
          });
        }
      }
    }
    throw lastError || new Error('Single-product cart normalization did not converge.');
  }

  async function clearThenNativeCheckout(variantId, sourceParams, anchor, fallbackHref) {
    if (!variantId) {
      window.location.href = fallbackHref || '/checkout';
      return;
    }

    if (inFlight) return;
    inFlight = true;
    setBusy(anchor);

    var mergedParams = mergeExitLandingOfferParams(sourceParams);
    var checkoutTarget = checkoutPath(mergedParams);
    var fallbackTarget = exactSingleProductCartUrl(variantId, mergedParams);

    if (hasRecentExactCartProof(variantId)) {
      window.__wsmSingleProductCheckoutLastActionV1 = {
        mode: 'reuse-recent-exact-cart-proof',
        variantId: String(variantId),
        at: Date.now()
      };
      checkoutNavigationPending = true;
      window.location.href = checkoutTarget;
      return;
    }

    try {
      await replaceCartWithSingleProduct(variantId);
      window.__wsmSingleProductCheckoutLastActionV1 = {
        mode: 'normalize-and-prove-exact-cart',
        variantId: String(variantId),
        at: Date.now()
      };
      checkoutNavigationPending = true;
      window.location.href = checkoutTarget;
    } catch (error) {
      clearExactCartProof();
      window.__wsmSingleProductCheckoutLastActionV1 = {
        mode: 'exact-cart-permalink-fallback',
        variantId: String(variantId),
        at: Date.now()
      };
      checkoutNavigationPending = true;
      window.location.href = fallbackTarget;
    }
  }

  function hasStoredExitCheckoutOffer() {
    // wsmRestoreExitOfferOnReturn20260707: Back/focus should repaint the saved POP20 timer state.
    var keys = ['wsm_v3d_one_time_offer_v68', 'wsm_v3d_one_time_offer_test_v1'];
    for (var i = 0; i < keys.length; i += 1) {
      try { if (window.localStorage.getItem(keys[i]) || window.sessionStorage.getItem(keys[i])) return true; } catch (error) {}
      try { if (String(document.cookie || '').indexOf(keys[i] + '=') !== -1) return true; } catch (error) {}
    }
    return false;
  }

  function restoreStoredExitOffer() {
    if (!hasStoredExitCheckoutOffer()) return;
    try {
      if (window.WSMV3DOneTimeOffer && typeof window.WSMV3DOneTimeOffer.render === 'function') {
        window.WSMV3DOneTimeOffer.render();
        return;
      }
    } catch (error) {}
    try {
      if (typeof window.WSMLoadLandingBehavior === 'function') {
        window.WSMLoadLandingBehavior('checkout-back-offer-restore');
      }
    } catch (error) {}
  }

  ['pageshow', 'focus', 'load'].forEach(function (eventName) {
    window.addEventListener(eventName, restoreStoredExitOffer);
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) restoreStoredExitOffer();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreStoredExitOffer, { once: true });
  } else {
    restoreStoredExitOffer();
  }
  window.setTimeout(restoreStoredExitOffer, 250);
  window.setTimeout(restoreStoredExitOffer, 1200);
  window.addEventListener('pageshow', function () {
    checkoutNavigationPending = false;
    resetBusyState();
  });
  window.addEventListener('pagehide', function () {
    if (!checkoutNavigationPending) clearExactCartProof();
  });

  document.addEventListener('click', function (event) {
    var anchor = closestAnchor(event.target);
    if (!anchor) return;

    var href = anchor.getAttribute('href') || '';

    if (isExitOfferCta(anchor)) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      var exitParams = paramsFromHash(href);
      activateExitLandingOffer(anchor, exitParams);
      clearThenNativeCheckout(findCurrentVariantId(anchor), exitParams, anchor, '/checkout');
      return;
    }

    if (href.indexOf('#wsm-dynamic-checkout') === 0) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      var sourceParams = paramsFromHash(href);
      persistExitCheckoutOffer(sourceParams);
      clearThenNativeCheckout(findCurrentVariantId(anchor), sourceParams, anchor, '/checkout');
      return;
    }

    var url = urlFromHref(href);
    if (!isCheckoutCartAdd(anchor, url)) {
      if (url && /\/cart\/(?:add|change|update|clear)(?:\.js)?$/i.test(url.pathname)) {
        clearExactCartProof();
      }
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    clearThenNativeCheckout(url.searchParams.get('id'), url.searchParams, anchor, href);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = closestForm(event.target);
    if (!form) return;

    var action = urlFromHref(form.getAttribute('action') || '');
    if (!action || !/\/cart\/add(?:\.js)?$/i.test(action.pathname)) return;

    var idInput = form.querySelector('[name="id"]');
    var id = idInput && idInput.value ? idInput.value : '';
    if (!id) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    clearThenNativeCheckout(id, new URLSearchParams(), form.querySelector('[type="submit"], button, a'), '/checkout');
  }, true);
})();
